const contactPageSchema = ({
  url,
  title,
  description,
  image,
}) => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "@id": `${url}#webpage`,
  url,
  name: title,
  description,

  isPartOf: {
    "@id": "https://irisimpulse.com/#website",
  },

  about: {
    "@id": "https://irisimpulse.com/#organization",
  },

  mainEntity: {
    "@id": "https://irisimpulse.com/#organization",
  },

  ...(image && {
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: image.startsWith("http")
        ? image
        : `https://irisimpulse.com/${image.replace(/^\/+/, "")}`,
    },
  }),

  inLanguage: "en",
});

export default contactPageSchema;
